import React from 'react';
import { Box } from '@mui/material';
import { BannerInfoBalanceIa } from './components/BannerInfoBalanceIa';
import { hasPemissions } from 'commons/utils';
import { PageLayout } from 'components/generics/PageLayout';
import { TableBalanceIa } from './components/TableBalanceIa';

export const BalanceIa = () => {
    const [canView, setCanView] = React.useState(false);

    const checkPermissions = async () => {
        const view = await hasPemissions('modulo.manager', 'modulo.manager.plataforma.ia', 'view', 'modulo.manager.plataforma.ia.comercial', 'modulo.manager.plataforma.ia.comercial.balance');
        setCanView(view);
    };

    React.useEffect(() => {
        checkPermissions();
    }, []);

    return (
        <PageLayout
            title="Balances de Créditos"
            mainModule="Plataforma IA"
            icon="AccountBalanceWallet"
            infoAlert="Administración y consulta de balances de créditos de las suscripciones de los clientes."
            actionButtons={<></>}
        >
            <TableBalanceIa />
            <BannerInfoBalanceIa />
        </PageLayout>
    );
};
